import React, { useEffect, useRef, useState } from 'react'
import SubTabChartingSection from './SubTabChartingSection'
import EmrRenderForm from './EmrRenderForm'
import EmrConfigService from "../../../services/EmrConfigService";
import EmrVisitsService from "../../../services/EmrVisitsService";
import { VISIT_CATEGORY } from '../../../utils/constant';
import StatusBar from "../../EmployeeVisitContainer/NewEmployeeVisitDetailView/RightContent/PhysicalTab/StatusBar";
import EmrStatusBar from '../Tabs/ComplaintPage/EmrStatusBar';
import { AI_TRIGGER_SCREEN_TYPES } from '../../../constants/aiScreenTypes';
const ChartingSection = (props) => {
   const {
    selectedSubTab,
    visit_id,
    setExpandedSection,
    fetchProgressNotesByScreen,
    Loader,
    Toast,
    employeeId,
    expandedSection,
    selectedTab,
    SetFinishedTabs,
    fetchTabsList,
    tabData,
    finishedSubTabs,
    finishedTabs,
    SetFinishedSubTabs,
    VISITCATEGORY,
    isChartingSectionDirty,
    setIsChartingSectionDirty,
    checkUnsavedChanges,
    onHpiSaved,
    refreshEmrFields,
    profile,
  } = props;

  // === State ===
  const [fields, setFields] = useState([]);
  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const [completedFormIds,setCompetedFormIds]=useState([])
  const [formResponses, setFormResponses] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [overallSearch, SetOverallSearch] = useState("");
  const [checkedHistoryId, setCheckedHistoryId] = useState(null);
  const [recommendedActivities, setRecommendedActivities] = useState([]);
  const [progressApiTrigger, setProgressApiTrigger] = useState(0);
  const [fieldSearched, SetFieldSearched] = useState(false);
  const [highlightTerm, setHighlightTerm] = useState(null);
  const [isSearchFromDropdown, setIsSearchFromDropdown] = useState(false);
  const [activeSearchSource, setActiveSearchSource] = useState(null);
  const [currentSearchLabel, setCurrentSearchLabel] = useState("");
  const [normalCheckedFormIds, setNormalCheckedFormIds] = useState([]);
  const [formState, setFormState] = useState({});
  const [isFormDirty, setIsFormDirty] = useState(false); 
  const [toggleStatus,setToggleStatus] = useState(false);

  // === Refs ===
  const searchTimeoutRef = useRef(null);
  const historyRef = useRef(null);
  const formCache = useRef({});
  const saveCurrentChartingRef = useRef(null);

  // === Effects ===
  useEffect(() => {
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => {
      if (searchTerm.trim() === "") fetchEmrList();
      else handleSearch();
    }, 500);
    return () => clearTimeout(searchTimeoutRef.current);
  }, [searchTerm]);
  useEffect(() => {
    console.log("isFormDirty changed:", isFormDirty);
    if(setIsChartingSectionDirty) {
        setIsChartingSectionDirty(isFormDirty);
    }
}, [isFormDirty]);

  useEffect(() => {
    fetchEmrList();
    setSearchTerm("");
    fetchRecommendedActivities();
  }, [selectedSubTab]);

  useEffect(() => {
    fetchProgressNotesByScreen();
  }, [visit_id, progressApiTrigger, selectedSubTab]);

   useEffect(() => {
    if(!toggleStatus){
        fetchEmrList();
   }            
  },[props.selectedBodyPart]);

  // Refresh EMR fields when refresh trigger changes
  useEffect(() => {
    if (props.refreshEmrTrigger !== undefined && props.refreshEmrTrigger > 0) {
      fetchEmrList();
      // Also reset form state and selections
      setNormalCheckedFormIds([]);
      setSelectedFormIds([]);
      setCompetedFormIds([]);
      setFormState({});
      setFormResponses({});
    }
  }, [props.refreshEmrTrigger]);

  const fetchFormDataById = async (apikey, id, forceRefresh = false) => {
    // Clear cache if forceRefresh is true
    if (forceRefresh && formCache.current[id]) {
      delete formCache.current[id];
    }
    // if (formCache.current[id]) return formCache.current[id];
    try {
      const response = await EmrConfigService.getEmrFormById(apikey, id);
      formCache.current[id] = response?.data;
      return response?.data;
    } catch (error) {
      console.error(`Failed to fetch form for ID: ${id}`, error);
      return null;
    }
  };

  const fetchRecommendedActivities = async () => {
    try {
      const response = await EmrVisitsService.searchHistory(
        null,
        selectedSubTab
      );
      const results = response.data.list || [];
      const activities = results.map((item, index) => ({
        id: item.search_reference_id || `check-${index}`,
        label: item.search_value || "Unnamed",
      }));
      setRecommendedActivities(activities);
    } catch (error) {
      console.error("Failed to fetch recommended activities:", error);
      setRecommendedActivities([]);
    }
  };

  const fetchMatchFiels = async (term, callback = () => {}) => {
    try {
      SetOverallSearch(term);
      if (!term) return callback([]);
      const response = await EmrVisitsService.searchActivities(
        null,
        selectedSubTab,
        { common_search: term }
      );
      const options = response.data.list.map((item) => ({
        label: item.name || item.value || item.label,
        value: item.id || item.emr_form_id,
      }));
      callback(options);
    } catch (error) {
      console.error("Failed to fetch activities:", error);
      callback([]);
    }
  };

  const handleSearch = async (id, value, shouldSetFields = true) => {
    try {
      const payload = {
        field_search: searchTerm || "",
        common_search: "",
        history_value_search: "",
        id,
        value,
      };
      const results = await EmrVisitsService.fetchFieldsBySearch(
        null,
        selectedSubTab,
        payload
      );
      fetchRecommendedActivities();
      if (shouldSetFields) {
        const fieldsData = (results.data?.data || []).map((item) => {
          const showNormal = item.show_normal === undefined || item.show_normal === null
            ? true
            : Number(item.show_normal) !== 0;
          return {
            emr_form_id: item.emr_form_id,
            name: item.name,
            display_as_section_header: item.display_as_section_header || 0,
            show_normal: showNormal,
          };
        });
        SetFieldSearched(true);
        setFields(fieldsData);
      }
    } catch (err) {
      console.error("Search failed:", err);
    }
  };

  const fetchEmrList = async (statusOverride = null) => {
    try {
      // Use statusOverride if provided, otherwise fall back to toggleStatus state
      const currentStatus = statusOverride !== null ? statusOverride : toggleStatus;
      const selectedBodyParts = currentStatus ? "" : props.selectedBodyPart || "";
      const response = await EmrVisitsService.getEmrChartByScreen(
        selectedSubTab,
        visit_id,
        { is_active: 1,
          selected_BodyParts: selectedBodyParts
          // selected_BodyParts:
         }
      );
      let fieldsData = [];
      let selectedIds = [];
      let completedIds = []; // Forms that have been saved (is_chart_updated)
      let normalIds = [];
      response.data.forEach((itm) => {
        const showNormal = itm.show_normal === undefined || itm.show_normal === null
          ? true
          : Number(itm.show_normal) !== 0;
        fieldsData.push({
          emr_form_id: itm.emr_form_id,
          name: itm.name,
          display_as_section_header: itm.display_as_section_header || 0,
          show_normal: showNormal,
        });
        if (itm.is_chart) selectedIds.push(itm.emr_form_id);
        // ✅ Include forms that have been saved (have data in SnapEmrChartingValueModel)
        if (itm.is_chart_updated) completedIds.push(itm.emr_form_id);
        if (itm.is_normal) normalIds.push(itm.emr_form_id);
        // if (itm.is_chart) handleCheckboxChange(itm.emr_form_id, true);
      });
      if (response.data.length > 0) {
        const documentedIds = [...new Set([...selectedIds, ...completedIds])];
        const sectionsWithCharting = fieldsData.filter((f) =>
          documentedIds.includes(f.emr_form_id)
        ).length;

        let formIdToSelect;
        if (sectionsWithCharting > 0 ) {
          // Land on first section that contains documentation
          const firstWithChart = fieldsData.find((f) =>
            documentedIds.includes(f.emr_form_id)
          );
          formIdToSelect = firstWithChart
            ? firstWithChart.emr_form_id
            : response.data[0].emr_form_id;
        } else {
          // No documentation: default to first non-header charting section
          const firstNonHeader = fieldsData.find(
            (f) => !f.display_as_section_header
          );
          formIdToSelect = firstNonHeader
            ? firstNonHeader.emr_form_id
            : response.data[0].emr_form_id;
        }
        handleCheckboxChange(formIdToSelect, true);
      }
      // ✅ Combine selectedIds (pending) and completedIds (saved) for completedFormIds
      // This ensures both "CHART" status and saved data show as charted
      setCompetedFormIds([...new Set([...selectedIds, ...completedIds])]);
      setNormalCheckedFormIds(normalIds);
      setFields(fieldsData);
      return fieldsData;
    } catch (e) {
      console.error("Fetch EMR Error:", e);
      return [];
    }
  };

  const handleCheckboxChange = async (
    emr_form_id,
    checked,
    replace = false,
    forceRefresh = false
  ) => {
    setSelectedFormIds((prev) =>
      checked
        ? [emr_form_id]
        : prev.filter((id) => id !== emr_form_id)
    );

    if (checked) {
      try {
        const form = await fetchFormDataById(selectedSubTab, emr_form_id, forceRefresh);
        const filledDataRes = await EmrVisitsService.fetchFilledFieldData(
          null,
          visit_id,
          emr_form_id
        );
        const filledFields = filledDataRes?.data?.data?.emr_field || [];
        const filledFieldMap = {};
        filledFields.forEach((field) => {
          field.id.forEach((id) => {
            filledFieldMap[id] = field.value;
          });
        });
        const prefilledForm = {
          ...form,
          fields: form.fields.map((field) => ({
            ...field,
            prefillValue: filledFieldMap[field.id] || "",
          })),
        };
        setFormResponses((prev) => {
          if (replace) return { ...prev, [selectedSubTab]: [prefilledForm] };
          const prevList = prev[selectedSubTab] || [];
          // Check if form already exists - if so, replace it instead of adding duplicate
          const existingIndex = prevList.findIndex(
            (formItem) => formItem.emr_form_id === prefilledForm.emr_form_id
          );
          if (existingIndex !== -1) {
            // Replace existing form with updated data
            const updatedList = [...prevList];
            updatedList[existingIndex] = prefilledForm;
            return { ...prev, [selectedSubTab]: updatedList };
          }
          // Form doesn't exist, add it
          return { ...prev, [selectedSubTab]: [...prevList, prefilledForm] };
        });
      } catch (error) {
        console.error("Error fetching prefilled field data:", error);
      }
    } else {
      // handleNormalSubmit(emr_form_id, 0, 1);
      setFormResponses((prev) => {
        const updated = (prev[selectedSubTab] || []).filter(
          (form) => form?.emr_form_id !== emr_form_id
        );
        return { ...prev, [selectedSubTab]: updated };
      });
    }
  };

  const handleNormalSubmit = async (form_id, isNormal = 0, is_clear = 0, clearAll = 0) => {
    try {
      // For clear-all flows, do not block by show_normal flag.
      const ids = String(form_id).split(",").map((id) => id.trim()).filter(Boolean);
      const shouldBypassShowNormalFilter = Number(clearAll) === 1 || Number(is_clear) === 1;
      const allowedIds = shouldBypassShowNormalFilter
        ? ids
        : ids.filter((id) => {
            const f = fields.find((field) => String(field.emr_form_id) === String(id));
            return f && f.show_normal;
          });
      if (allowedIds.length === 0) return;
      const formIdToSave = allowedIds.join(",");
      const payload = {
        employee_id: employeeId,
        screen_type: selectedSubTab,
        emr_field: "",
        is_normal: isNormal,
        chart_update: 0,
        is_clear: is_clear,
        clear_normal: isNormal === 0 ? 1 : 0, // Add clear_normal = 1 when normal is unchecked
        clear_all: clearAll, // Add clear_all = 1 for "Clear All" button, 0 for "clear normal"
      };
      Loader(true);
      const result = await EmrVisitsService.saveFields(
        null,
        visit_id,
        formIdToSave,
        payload
      );
      Loader(false);
      if (result?.status === 200 || result?.status === "SUCCESS" || result?.code === 200) {
        if (isNormal === 1) {
          Toast.success("Marked as normal successfully.");
        }
        fetchProgressNotesByScreen();
      } else {
        Toast.error("Failed to mark as normal.");
      }
    } catch (err) {
      Loader(false);
      console.error("Normal save failed:", err);
      Toast.error("Something went wrong.");
    }
  };

  const handleFormUpdate = async (form_id) => {
    try {
      const form = await fetchFormDataById(selectedSubTab, form_id);
      const filledDataRes = await EmrVisitsService.fetchFilledFieldData(
        null,
        visit_id,
        form_id
      );
      const filledFields = filledDataRes?.data?.data?.emr_field || [];
      const filledFieldMap = {};
      filledFields.forEach((field) => {
        field.id.forEach((id) => {
          filledFieldMap[id] = field.value;
        });
      });
      const updatedForm = {
        ...form,
        fields: form.fields.map((field) => ({
          ...field,
          prefillValue: filledFieldMap[field.id] || "",
        })),
      };
      setFormResponses((prev) => {
        const prevList = prev[selectedSubTab] || [];
        const updatedList = prevList.map((f) =>
          f.emr_form_id === form_id ? updatedForm : f
        );
        return { ...prev, [selectedSubTab]: updatedList };
      });

      // If this save was for an AI-relevant history section, notify parent so AI can refresh once
      if (AI_TRIGGER_SCREEN_TYPES.includes(selectedSubTab) && typeof onHpiSaved === "function") {
        onHpiSaved();
      }
    } catch (err) {
      console.error("Failed to refresh filled form:", err);
    }
  };

  const handleHistoryClick = async (selectedId) => {
    const matchedForm = fields.find(
      (f) => String(f.emr_form_id) === String(selectedId)
    );
    if (matchedForm) {
      await handleCheckboxChange(matchedForm.emr_form_id, true, true);
      setFields([
        { emr_form_id: matchedForm.emr_form_id, name: matchedForm.name },
      ]);
      setExpandedSection(matchedForm.emr_form_id);
      setHighlightTerm(matchedForm.name);
      handleSearch(matchedForm.emr_form_id, matchedForm.name, false);
      setCurrentSearchLabel(matchedForm.name);
      return;
    }

    const allFormIds = fields.map((f) => f.emr_form_id);
    const formDetailsList = await Promise.all(
      allFormIds.map((id) => fetchFormDataById(selectedSubTab, id))
    );

    for (let i = 0; i < formDetailsList.length; i++) {
      const form = formDetailsList[i];
      const originalField = fields[i];

      for (const field of form.fields) {
        if (String(field.id) === String(selectedId)) {
          await handleCheckboxChange(originalField.emr_form_id, true, true);
          setFields([
            {
              emr_form_id: originalField.emr_form_id,
              name: originalField.name,
            },
          ]);
          setExpandedSection(originalField.emr_form_id);
          setHighlightTerm(field.label);
          setCurrentSearchLabel(field.label);
          handleSearch(field.id, field.label, false);
          return;
        }

        const matchedOption = (field.options || []).find(
          (opt) => String(opt.id) === String(selectedId)
        );
        if (matchedOption) {
          await handleCheckboxChange(originalField.emr_form_id, true, true);
          setFields([
            {
              emr_form_id: originalField.emr_form_id,
              name: originalField.name,
            },
          ]);
          setExpandedSection(originalField.emr_form_id);
          setHighlightTerm(matchedOption.value || field.label);
          setCurrentSearchLabel(matchedOption.value);
          handleSearch(
            matchedOption.id,
            matchedOption.value || field.label,
            false
          );
          return;
        }
      }
    }

    setFields([]);
    setFormResponses((prev) => ({ ...prev, [selectedSubTab]: [] }));
    setSelectedFormIds([]);
    setExpandedSection(null);
    setHighlightTerm(null);
    setCurrentSearchLabel("No Match Found");
  };

  const checkHandle = (val, _eventWrapper, id, label) => {
    if (val) {
      setCheckedHistoryId(id);
      setActiveSearchSource("history");
      setCurrentSearchLabel(label);
      handleHistoryClick(id);
    } else {
      setCheckedHistoryId(null);
      setHighlightTerm(null);
      setSearchTerm("");
      setActiveSearchSource(null);
      setCurrentSearchLabel("");
      handleSearch();
      fetchEmrList();
      setIsFormDirty(false)
    }
  };
  const handleTick=async(maintabs,subtabs)=>{
    try{
      
      const payload = tabData.map((tab) => ({
        ...tab,
        tab_status: maintabs.includes(tab.tab_name) ? "COMPLETED" : "NOT STARTED",
        [tab.tab_name]: tab[tab.tab_name]?.map((subtab) => ({
          ...subtab,
          sub_tab_status: subtabs.includes(subtab.apikey)
            ? "COMPLETED"
            : "NOT STARTED",
        })) || [],
      }));
      const response = await EmrConfigService.setTabsListstatus(visit_id,payload,VISITCATEGORY)
        console.log("response",response);
      if(response){
        fetchTabsList()
      }
    }catch(err){

    }finally{

    }
  }
  const allSelected =
    fields.length > 0 &&
    fields.every((f) => selectedFormIds.includes(f.emr_form_id));
  let child1Callback; 
   const registerChild1Handler = (fn) => {
    child1Callback = fn;
  };
  console.log(child1Callback,"child1Callback");

  // When switching charting sections: auto-save current charting then proceed (no unsaved modal).
  // If save fails (e.g. required fields missing), do not switch — stay on current chart.
  const saveCurrentChartingAndProceed = async (callback) => {
    if (isChartingSectionDirty && saveCurrentChartingRef.current) {
      const success = await saveCurrentChartingRef.current();
      if (!success) return; // stay on current chart; toast and focus handled in EmrRenderForm
      if (setIsChartingSectionDirty) setIsChartingSectionDirty(false);
      if (setIsFormDirty) setIsFormDirty(false);
    }
    callback();
  };
  
  return (

    <div class="row">
      {/* Status bar start here */}
      <div
        className="sh_cardHeader mb-3 rounded-2"
        style={{
          background: "linear-gradient(90deg, #FFF7DC 0%, #F7E9E5 100%)",
        }}
      >
        <div className="d-flex justify-content-center">
          <div className="form-group d-flex mb-0 justify-content-between align-items-center">
            <EmrStatusBar visitDetails={props.visitDetails} />
          </div>
        </div>
      </div>

      
      <SubTabChartingSection
        fields={fields}
        subTabs={props.subTabs}
        normalCheckedFormIds={normalCheckedFormIds}
        handleNormalSubmit={handleNormalSubmit}
        setNormalCheckedFormIds={setNormalCheckedFormIds}
        setSelectedFormIds={setSelectedFormIds}
        selectedFormIds={selectedFormIds}
        handleCheckboxChange={handleCheckboxChange}
        fieldSearched={fieldSearched}
        handleSearch={handleSearch}
        SetFieldSearched={SetFieldSearched}
        allSelected={allSelected}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setActiveSearchSource={setActiveSearchSource}
        setCurrentSearchLabel={setCurrentSearchLabel}
        activeSearchSource={activeSearchSource}
        selectedTab={selectedTab}
        selectedSubTab={selectedSubTab}
        completedFormIds={completedFormIds}
        setCompetedFormIds={setCompetedFormIds}
        SetFinishedTabs={SetFinishedTabs}
        SetFinishedSubTabs={SetFinishedSubTabs}
        handleTick={handleTick}
        finishedSubTabs={finishedSubTabs}
        finishedTabs={finishedTabs}
        setFormState={setFormState}
        formState={formState}
        formResponses={(formResponses[selectedSubTab] || [])}
        isChartingSectionDirty={isChartingSectionDirty}
        setIsChartingSectionDirty={setIsChartingSectionDirty}
        checkUnsavedChanges={checkUnsavedChanges}
        saveCurrentChartingAndProceed={saveCurrentChartingAndProceed}
        visit_id={visit_id}
        fetchEmrList={fetchEmrList}
        fetchTabsList={fetchTabsList}
        refreshEmrFields={refreshEmrFields || fetchEmrList}
        setToggleStatus={setToggleStatus}
        toggleStatus={toggleStatus}
        visitDetails={props.visitDetails}
        employeeId={employeeId}
        profile={profile}
        fetchProgressNotesByScreen={fetchProgressNotesByScreen}
        Loader={props.Loader}
      />
      <EmrRenderForm
        setProgressApiTrigger={setProgressApiTrigger}
        fetchProgressNotesByScreen={fetchProgressNotesByScreen}
        fields={(formResponses[selectedSubTab] || []).filter((form) =>
          selectedFormIds.includes(form.emr_form_id)
        )}
        allfields={(formResponses[selectedSubTab] || [])}
        visit_id={visit_id}
        employeeId={employeeId}
        Toast={Toast}
        highlightTerm={highlightTerm}
        expandedSection={expandedSection}
        setExpandedSection={setExpandedSection}
        selectedSubTab={selectedSubTab}
        onFormUpdate={handleFormUpdate}
        selectedTab={selectedTab}
        handleNormalSubmit={handleNormalSubmit}
        completedFormIds={completedFormIds}
        setCompetedFormIds={setCompetedFormIds}
        SetFinishedTabs={SetFinishedTabs}
        fetchTabsList={fetchTabsList}
        tabData={tabData}
        finishedSubTabs={finishedSubTabs}
        finishedTabs={finishedTabs}
        SetFinishedSubTabs={SetFinishedSubTabs}
        handleTick={handleTick}
        setNormalCheckedFormIds={setNormalCheckedFormIds}
        setFormState={setFormState}
        formState={formState}
        ToggleOrders={props.ToggleOrders}
        addVaccineToogleHandler={props.addVaccineToogleHandler}
        setIsFormDirty={setIsFormDirty}
        isFormDirty={isFormDirty}
        registerSaveCurrentCharting={(fn) => { saveCurrentChartingRef.current = fn; }}
        {...props}
      />
    </div>

  )
}

export default ChartingSection